"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const editor_1 = require("../../../../utils/editor");
const editor_2 = require("../../../constants/editor");
const button_style_1 = __importDefault(require("./button.style"));
const Button = ({ classes, icon, onClick, promptForLink, removeLink, active, buttonType, disabled }) => {
    /**
     * the local isActive variable monitors block and inline styles active state
     * For link button, the active state is monitored within the richEditor component.
     */
    const [isActive, setActive] = react_1.useState(active);
    const handleClick = e => {
        e.preventDefault(); // Allows to lock the key command
        if (!disabled && onClick) {
            setActive(true);
            onClick(buttonType);
        }
        editor_1.STYLE.map(type => type === buttonType && setActive(false));
    };
    const toggleLink = e => {
        e.preventDefault(); // Allows to lock the key command
        if (!disabled && !active)
            return promptForLink(e);
        return removeLink();
    };
    const rootProps = {
        // onMouseDown has to be used instead of onClick to be able to lock the key command
        className: classes.root,
        type: 'button',
        disabled,
        'data-is-active': isActive || active
    };
    let label;
    switch (buttonType) {
        case editor_2.HEADER_ONE:
            label = 'H1';
            break;
        case editor_2.BOLD:
            label = 'B';
            break;
        case editor_2.LINK:
            label = 'L';
            break;
        case editor_2.UNORDERED_LIST_ITEM:
            label = 'UL';
            break;
        default:
            label = buttonType[0].toUpperCase();
    }
    return (jsx_runtime_1.jsx("button", Object.assign({ onMouseDown: buttonType === editor_2.LINK ? toggleLink : handleClick }, rootProps, { children: jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: icon || label }), void 0) }), void 0));
};
exports.Button = Button;
exports.Button.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    icon: prop_types_1.default.node,
    onClick: prop_types_1.default.func,
    promptForLink: prop_types_1.default.func,
    removeLink: prop_types_1.default.func,
    active: prop_types_1.default.bool,
    buttonType: prop_types_1.default.string.isRequired,
    disabled: prop_types_1.default.bool
};
exports.Button.defaultProps = {
    icon: null,
    onClick: () => { },
    promptForLink: () => { },
    removeLink: () => { },
    active: false,
    disabled: false
};
exports.default = react_jss_1.default(button_style_1.default)(exports.Button);
//# sourceMappingURL=index.js.map